import assert from 'assert-ts';
import type {MultiThesaurusValue} from 'sceneExtensions/extensions/multiThesaurusEdit/types';
import type {ThesaurusId, ThesaurusMap} from 'services/thesaurus/types';
import type {MultiSearchResult} from '../types';
import {searchThesaurus} from '../../editThesaurus/functions';

export const searchMultiThesaurus = (
  /** Search query, may start with 'code:' to limit search to categories starting with code */
  query: string,
  thesaurusValues: MultiThesaurusValue,
  thesauruses: ThesaurusMap,
): MultiSearchResult => {
  const result = (
    Object.keys(thesauruses) as ThesaurusId[]
  ).reduce<MultiSearchResult>((acc, id) => {
    const thesaurusId = id as ThesaurusId;
    const thesaurus = assert(
      thesauruses[thesaurusId as ThesaurusId],
      `searchMultiThesaurus: Thesaurus ${thesaurusId} not found`,
    );
    const value = thesaurusValues[thesaurusId];
    return {
      ...acc,
      [thesaurusId]: searchThesaurus(
        query,
        value,
        () => undefined,
        thesaurus,
      ).filter(m => m.hasTitleMatch || m.hasSynonymMatch),
    };
  }, {});

  return result;
};
